"use client"

import { useState, useEffect } from "react"
import { Check, Loader2, AlertCircle } from "lucide-react"
import { cn } from "@/lib/utils"

type SaveStatus = 'idle' | 'saving' | 'saved' | 'error'

interface SaveIndicatorProps {
  status?: SaveStatus
}

export function SaveIndicator({ status: externalStatus }: SaveIndicatorProps) {
  const [status, setStatus] = useState<SaveStatus>(externalStatus || 'idle')

  useEffect(() => {
    if (externalStatus) {
      setStatus(externalStatus)
    }
  }, [externalStatus])

  if (status === 'idle') return null

  return (
    <div className="fixed top-4 right-4 z-50">
      <div
        className={cn(
          "flex items-center gap-2 px-4 py-2 rounded-lg shadow-lg border backdrop-blur-sm",
          status === 'saving' && "bg-yellow-50 border-yellow-200 text-yellow-800",
          status === 'saved' && "bg-green-50 border-green-200 text-green-800",
          status === 'error' && "bg-red-50 border-red-200 text-red-800"
        )}
      >
        {status === 'saving' && <Loader2 className="h-4 w-4 animate-spin" />}
        {status === 'saved' && <Check className="h-4 w-4" />}
        {status === 'error' && <AlertCircle className="h-4 w-4" />}
        <span className="text-sm font-medium">
          {status === 'saving' && 'Saving...'}
          {status === 'saved' && 'Saved'}
          {status === 'error' && 'Error saving'}
        </span>
      </div>
    </div>
  )
}

